module.exports = __webpack_public_path__ + "img/GB-SCT.dd6733a9.svg";